module.exports = __webpack_public_path__ + "img/es_icon_5.e668ee43.png";